import React from "react";
import ReactWordCloud from "react-wordcloud";

export default class Desiderata extends React.Component {
  render() {
    const words = [
      { text: "Structure-insensitive", value: 20 },
      { text: "Fast", value: 12 },
      { text: "Specific", value: 12 },
      { text: "Composable", value: 12 },
      { text: "Behavioral", value: 20 },
      { text: "Inspiring", value: 10 },
      { text: "Readable", value: 12 },
      { text: "Writable", value: 20 },
      { text: "Automated", value: 10 },
      { text: "Deterministic", value: 12 },
      { text: "Isolated", value: 20 },
      { text: "Predictive", value: 10 },
    ];

    const options = {
      colors: [
        "rgb(227, 119, 194)",
        "rgb(57, 58, 52)",
        "#00a4db",
        "rgb(57, 58, 52)",
        "rgb(23, 190, 207)",
        "#e3116c",
      ],
      enableTooltip: false,
      deterministic: true,
      fontFamily: "system-ui,sans-serif",
      fontWeight: "bold",
      fontSizes: [30, 120],
      padding: 10,
      rotations: 1,
      rotationAngles: [0, 90],
      spiral: "archimedean",
      transitionDuration: 1000,
    };

    return (
      <div
        style={{
          height: "100vh",
          width: "100vw",
        }}
      >
        <ReactWordCloud words={words} options={options} />
      </div>
    );
  }
}
